/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';
const QuoteDetails = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom     for any jQuery selectors    - example: $domMenu: $('.js-menu')
	 * @param {string} sl       for any string selectors    - example: slMenu: '.js-menu'
	 * @param {string} class    for any class strings       - example: classActive: 'is-active'
	 * @param {string} attr     for any attributes strings  - example: attrIndex: 'data-index'
	 */

	$domLoaderSelector: $('.js-quote-click'),

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		this.bindEvents();
		this.loadingQuote();
		this.typeWidget();
		this.cloningFields();
		this.inputDisabling();
		/* this.calculateButton(); */
		this.switchPlaces();
		this.mobileSwitch();
		this.showTooltip();
	},
	/**
	 * @param  {} evItem item we click on
	 * @param  {} targetItem target
	 * @param  {} className class
	 */
	classSwitchInputs: function(evItem, targetItem, className) {
		evItem.on('keyup', function() {
			if($(this).val() !== '') {
				targetItem.addClass(className);
			}else {
				targetItem.removeClass(className);
			}
		});
	},
	/**
	 * @param  {} evItem item we click on
	 * @param  {} firstTarget target
	 * @param  {} secondTarget target
	 * @param  {} thirdTarget target
	 * @param  {} className class
	 */
	classSwitchCBM: function(evItem, firstTarget, secondTarget, thirdTarget, className) {
		evItem.on('keyup', function() {
			if($(this).val() !== '') {
				firstTarget.addClass(className);
				secondTarget.addClass(className);
				thirdTarget.addClass(className);
			}else {
				firstTarget.removeClass(className);
				secondTarget.removeClass(className);
				thirdTarget.removeClass(className);
			}
		});
	},
	/**
	 * @param  {} evItem item we click on
	 * @param  {} classItem target
	 * @param  {} className class
	 */
	classSwitchForCalculatingInputsOnCartonAndKG: function(evItem, classItem, className) {
		$(document).on('keyup', evItem, function(){
			if(!$(evItem).val() && !$(this).val()) {
				$(classItem).removeClass(className);
			}else {
				$(classItem).addClass(className);
			}
		});
	},
	/**
	 * @param  {} evItem
	 * @param  {} evItemSecond
	 * @param  {} evItemThird
	 * @param  {} switchItem
	 * @param  {} className
	 */
	classSwitchForCalculatingInputsOnWidthLenghtAndHeight: function(evItem, evItemSecond, evItemThird, switchItem, className) {
		$(document).on('keyup', evItem, function(){
			$(evItem).each(function() {
				if(!$(evItem).val() && !$(evItemSecond).val() && !$(evItemThird).val()) {
					switchItem.removeClass(className);
				}else {
					switchItem.addClass(className);
				}
			});
		});
	},

	mobileSwitch: function() {
		if($(window).width() < 576) {
			setTimeout(() => {
				$('.js-location-widget').addClass('data-show');
			}, 2000);
		}
	},

	switchPlaces: function() {
		// $('.js-location-widget__image').on('click', function() {
		// 	$(this).parent().toggleClass('items-swapped');
		// 	if(!$(this).parent().hasClass('items-swapped')) {
		// 		$('.js-location-widget__input--big-first').insertBefore('.js-location-widget__image');
		// 		$('.js-location-widget__input--big-second').insertAfter('.js-location-widget__image');
		// 		$('.js-location-widget__image-txt-switch').text('Export');
		// 	}else {
		// 		$('.js-location-widget__input--big-first').insertAfter('.js-location-widget__image');
		// 		$('.js-location-widget__input--big-second').insertBefore('.js-location-widget__image');
		// 		$('.js-location-widget__image-txt-switch').text('Import');
		// 	}
		// });
	},

	inputDisabling: function() {
		//Class switch inputs for Carton Count on AIR tab
		this.classSwitchInputs($('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="Count"]'), $('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="CA"]'), 'input-disabled');

		//Class switch inputs for KG on AIR tab
		this.classSwitchInputs($('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="Weight"]'), $('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="WE"]'), 'input-disabled');

		//Class switch inputs for Carton Count on OCEAN tab
		this.classSwitchInputs($('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="Count"]'), $('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="CA"]'), 'input-disabled');

		//Class switch inputs for KG on OCEAN tab
		this.classSwitchInputs($('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="Weight"]'), $('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="WE"]'), 'input-disabled');

		//////////////////////////////////////////////////
		//Class switch CBM for AIR tab
		this.classSwitchCBM($('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="cbm"]'), $('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="WI"]'), $('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="L"]'), $('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="H"]'), 'input-disabled');

		//Class switch CBM for OCEAN tab
		this.classSwitchCBM($('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="cbm"]'), $('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="WI"]'), $('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="L"]'), $('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="H"]'), 'input-disabled');

		$(document).on('keyup', '.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="CA"]', function(){
			if(!$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="CA"]').val() && !$(this).val()) {
				$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="Count"]').removeClass('input-disabled');
			}else {
				$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="Count"]').addClass('input-disabled');
			}
		});

		$(document).on('keyup', '.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="WE"]', function(){
			if(!$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="WE"]').val() && !$(this).val()) {
				$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="Weight"]').removeClass('input-disabled');
			}else {
				$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="Weight"]').addClass('input-disabled');
			}
		});
		/////

		$(document).on('keyup', '.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="WI"]', function(){
			$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="WI"]').each(function() {
				if(!$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="WI"]').val() && !$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="L"]').val() && !$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="H"]').val()) {
					$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="cbm"]').removeClass('input-disabled');
				}else {
					$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="cbm"]').addClass('input-disabled');
				}
			});
		});

		$(document).on('keyup', '.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="L"]', function(){
			$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="L"]').each(function() {
				if(!$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="WI"]').val() && !$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="L"]').val() && !$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="H"]').val()) {
					$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="cbm"]').removeClass('input-disabled');
				}else {
					$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="cbm"]').addClass('input-disabled');
				}
			});
		});

		$(document).on('keyup', '.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="H"]', function(){
			$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="H"]').each(function() {
				if(!$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="WI"]').val() && !$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="L"]').val() && !$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="H"]').val()) {
					$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="cbm"]').removeClass('input-disabled');
				}else {
					$('.location-widget__input-dropdown-wrapper--inputs-air [data-shorthand="cbm"]').addClass('input-disabled');
				}
			});
		});

		//Class switch for calculating inputs on Carton amount OCEAN tab
		this.classSwitchForCalculatingInputsOnCartonAndKG('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="CA"]', '.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="Count"]', 'input-disabled');

		//Class switch for calculating inputs on KG OCEAN tab
		this.classSwitchForCalculatingInputsOnCartonAndKG('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="WE"]', '.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="Weight"]', 'input-disabled');

		//Class switch for calculations on Ocean Tab
		this.classSwitchForCalculatingInputsOnWidthLenghtAndHeight('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="WI"]', '.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="L"]', '.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="H"]', $('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="cbm"]'), 'input-disabled');

		this.classSwitchForCalculatingInputsOnWidthLenghtAndHeight('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="L"]', '.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="WI"]', '.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="H"]', $('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="cbm"]'), 'input-disabled');

		this.classSwitchForCalculatingInputsOnWidthLenghtAndHeight('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="H"]', '.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="WI"]', '.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="L"]', $('.location-widget__input-dropdown-wrapper--inputs-ocean [data-shorthand="cbm"]'), 'input-disabled');
	},

	cloningFields: function() {
		/* let arr = []; */
		const addBtn = $('.js-add-new-set');
		const dParent = $('.location-widget__input-dropdown-type-wrapper[data-dropdown="3"] .js-dropdown-parent');
		const fieldWrapp = $('.js-location-widget__inputs-box:first');
		const removeBtn = $('.js-remove-new-set');

		/* arr.push(fieldWrapp); */

		//adding new fields AIR
		addBtn.on('click', function() {
			fieldWrapp.clone().appendTo(dParent);
			// for (let i = 0; i < fieldWrapp.length; i++) {
			// 	const element = fieldWrapp[i];
			// 	arr.push(element);
			// 	arr.forEach((ele) => {
			// 		$(ele[0]).clone().appendTo(dParent);
			// 	});
			// }
		});

		//removing newest fields AIR
		removeBtn.on('click', function() {
			const children = $('.location-widget__input-dropdown-type-wrapper[data-dropdown="3"] .active .js-dropdown-parent').children('.js-location-widget__inputs-box');
			if(children.length > 1) {
				children.last().remove();
			}
		});


		//Ocean selectors
		const addBtnOcean =$('.js-add-new-set--ocean');
		const dParentOcean = $('.location-widget__input-dropdown-wrapper--inputs-ocean').find('.js-dropdown-parent');
		const fieldWrappOcean = $('.js-location-widget__inputs-box-ocean:first');

		//adding new fields OCEAN
		addBtnOcean.on('click', function() {
			fieldWrappOcean.clone().appendTo(dParentOcean);
		});
	},

	bindEvents: function() {

		this.$domLoaderSelector.on('click', function(e) {

			const city1 = $('#select2-location-widget__input-in-from-container').text();

			const city2 = $('#select2-location-widget__input-in-to-container').text();

			const jsDate = $('.js-date').val();

			/* const jsType = $('.js-type').val(); */

			const jsType = $('.js-type').val();

			const jsTypeTxt = $('.js-type-calc').val();

			if(city1 === city2) {
				$('.location-widget__input').addClass('error');
				$('.js-location-widget-error').css('display', 'block');
				e.preventDefault();
				return;
			}

			if (city1) {
				localStorage.setItem('city-1', city1);
			}

			if (city2) {
				localStorage.setItem('city-2', city2);
			}

			if (jsDate) {
				localStorage.setItem('js-date', jsDate);
			}

			if (jsType) {
				localStorage.setItem('js-type', jsType);
			}

			if (jsTypeTxt) {
				localStorage.setItem('js-type-calc', jsTypeTxt);
			}

		});
	},

	loadingQuote: function() {
		$(() => {
			if (localStorage['city-1']) {
				// Set the option localStorage.getItem('city-1') to the value of the option on load
				$('#select2-location-widget__input-in-from-container').text(localStorage['city-1']);
				localStorage.removeItem('city-1');
			}

			if (localStorage['city-2']) {
				// Set the option localStorage.getItem('city-2') to the value of the option on load
				$('#select2-location-widget__input-in-to-container').text(localStorage['city-2']);
				localStorage.removeItem('city-2');
			}

			if (localStorage['js-date']) {
				$('.js-date-new').val(localStorage.getItem('js-date'));
				localStorage.removeItem('js-date');
			}

			if (localStorage['js-type']) {
				$('.js-type-new').val(localStorage.getItem('js-type'));
				localStorage.removeItem('js-type');
			}

			if (localStorage['js-type-calc']) {
				$('.js-type-calc').val(localStorage.getItem('js-type-calc'));
				localStorage.removeItem('js-type-calc');
			}

		});
	},

	showTooltip: function() {
		const tooltip = $('.js-tooltip');
		const image = $('.js-location-widget__image');

		image.on('mouseenter', function() {
			tooltip.addClass('tooltip-active');
		});
		image.on('mouseleave', function() {
			tooltip.removeClass('tooltip-active');
		});
	},

	typeWidget: function() {

		//OPPENING AND CLOSING WIDGET ------------

		//Trigger widget
		$('.js-type').on('click', function() {
			$('.location-widget__input-dropdown').toggleClass('active');
		});

		//Close widget if clicked outside of it
		$(document).on('click', function(e) {
			if (!$(e.target).closest('.location-widget__input-dropdown').length && !$(e.target).closest('.js-type').length) {
				$('.location-widget__input-dropdown').removeClass('active');
			}
		});

		$('.js-date').on('click touchstart', function() {
			$('.location-widget__input-dropdown').removeClass('active');
			$('.js-type').focusout();
			$('.js-type').parent().removeClass('is-active');
		});

		//-----------------------------------------------------------------------------------------

		// MAIN TABS SWITCHING CONTENT (SHIPPING TYPE) ------------

		// Shipping type change
		$('.js-type-btn').on('click', function() {
			// Get clicked element data attribute
			const type = $(this).data('type');
			// Set active class on clicked element and remove from others
			$('.js-type-btn').removeClass('location-widget__input-dropdown-button--active');
			$(this).addClass('location-widget__input-dropdown-button--active');

			//Find location-widget__input-dropdown-type-wrapper element with the data-dropdown value as clicked element
			$('.location-widget__input-dropdown-type-wrapper').each(function() {
				if ($(this).data('dropdown') === type) {
					$(this).addClass('active');
				} else {
					$(this).removeClass('active');
				}
			});

			// Close all dropdowns once you change shipping type
			$('.location-widget__input-dropdown-type-wrapper .js-dropdown').parents('.js-dropdown-parent').find('.js-options').removeClass('active');

			// Set theme color class for parent element
			if(type === 1){
				$(this).parents('.location-widget__input-dropdown').addClass('blue').removeClass('red green');
			} else if(type === 2){
				$(this).parents('.location-widget__input-dropdown').addClass('green').removeClass('blue red');
			} else if(type === 3){
				$(this).parents('.location-widget__input-dropdown').addClass('red').removeClass('blue green');
			}
			$('.js-options, .js-dropdown').removeClass('active');
		});

		//-----------------------------------------------------------------------------------------

		//TOGGLING DROPDOWN MENUS

		// Shipping type dropdown show/hide
		$('.location-widget__input-dropdown-type-wrapper .js-dropdown').on('click', function() {
			const optionsElement = $(this).parents('.js-dropdown-parent').find('.js-options');

			if(optionsElement.hasClass('active')){
				optionsElement.removeClass('active');
			} else {
				$('.location-widget__input-dropdown-type-wrapper .js-dropdown').parents('.js-dropdown-parent').find('.js-options').removeClass('active');
				optionsElement.addClass('active');
			}
			// Adding active class for arrow icon rotation
			$(this).toggleClass('active');
		});

		//-----------------------------------------------------------------------------------------

		//FUNCTINALITY FOR SETTING CLICKED ELEMENT FROM DROPDOWN

		// On .js-option element click, take its value and set it to the .js-dropdown element
		$('.js-option').on('click', function() {
			// Take only parent text, not its children
			const optionValue = $($(this).contents()[0]).text();
			const dataAttribute = $(this).attr('data-shorthand');
			const dropdownElement = $(this).parents('.js-dropdown-parent').find('.js-dropdown');

			// Take only parent text, not its children, and set it to .js-dropdown element.
			dropdownElement.text(optionValue);
			// Set attribute value for element
			dropdownElement.attr('data-shorthand', dataAttribute);
			// Close dropdown and remove active class for dropdown, to reset arrow pointig down, when option is selected.
			$('.js-options, .js-dropdown').removeClass('active');
		});

		$('.js-option[data-shorthand="LCL"]').on('click', function() {
			$('.location-widget__input-dropdown-wrapper--inputs-ocean').addClass('data-show');
		});

		$('.js-option[data-shorthand="FCL"]').on('click', function() {
			$('.location-widget__input-dropdown-wrapper--inputs-ocean').removeClass('data-show');
		});

		//-----------------------------------------------------------------------------------------

		//Calculating for AIR Type

		$('.js-calculate--air').on('click', function() {

			//height * width * length
			const totalArr = [];
			let totalSum = 0;
			const allInp = $('.location-widget__input-dropdown-wrapper--inputs-air .js-dropdown-parent').find('.js-location-widget__inputs-box');
			allInp.each(function() {
				const height = Number($(this).find('[data-shorthand="H"]').val());
				const width = Number($(this).find('[data-shorthand="WI"]').val());
				const length = Number($(this).find('[data-shorthand="L"]').val());
				const val = height * width * length / 1000000;
				totalArr.push(val);
			});

			for (let i = 0; i < totalArr.length; i++) {
				const element = totalArr[i];
				totalSum += element;
			}

			//carton Count
			const cartonItems = $('.location-widget__input-dropdown-wrapper--inputs-air .js-dropdown-parent').find('[data-shorthand="CA"]');
			let cartonAmount = 0;
			cartonItems.each(function() {
				cartonAmount += Number($(this).val());
			});


			//Weight total
			const weightItems = $('.location-widget__input-dropdown-wrapper--inputs-air .js-dropdown-parent').find('[data-shorthand="WE"]');
			let sumWeight = 0;
			weightItems.each(function() {
				sumWeight += Number($(this).val());
			});

			const totalAddition = `Amount ${cartonAmount}; ${sumWeight}KG; CBM ${totalSum}`;


			//Write input for Carton Count
			const countAir = $('.location-widget__input-dropdown-wrapper--inputs-air .location-widget__input-top-box').find('[data-shorthand="Count"]');
			if(!countAir.val() || countAir.hasClass('input-disabled')) {
				countAir.val(cartonAmount);
			}

			//Write input for KG
			const KgAir = $('.location-widget__input-dropdown-wrapper--inputs-air .location-widget__input-top-box').find('[data-shorthand="Weight"]');
			if(!KgAir.val() || KgAir.hasClass('input-disabled')) {
				KgAir.val(sumWeight);
			}

			//Write input for CBM
			const cbmAir = $('.location-widget__input-dropdown-wrapper--inputs-air .location-widget__input-top-box').find('[data-shorthand="cbm"]');
			if(!cbmAir.val() || cbmAir.hasClass('input-disabled')) {
				cbmAir.val(totalSum);
			}
		});


		//-----------------------------------------------------------------------------------------

		//Calculating for OCEAN Type

		$('.js-calculate--ocean').on('click', function() {

			//height * width * length
			const totalArr = [];
			let totalSum = 0;
			const allInp = $('.location-widget__input-dropdown-wrapper--inputs-ocean .js-dropdown-parent').find('.js-location-widget__inputs-box-ocean');
			allInp.each(function() {
				const height = Number($(this).find('[data-shorthand="H"]').val());
				const width = Number($(this).find('[data-shorthand="WI"]').val());
				const length = Number($(this).find('[data-shorthand="L"]').val());
				const val = height * width * length / 1000000;
				totalArr.push(val);
			});

			for (let i = 0; i < totalArr.length; i++) {
				const element = totalArr[i];
				totalSum += element;
			}

			//carton Count
			const cartonItems = $('.location-widget__input-dropdown-wrapper--inputs-ocean .js-dropdown-parent').find('[data-shorthand="CA"]');
			let cartonAmount = 0;
			cartonItems.each(function() {
				cartonAmount += Number($(this).val());
			});


			//Weight total
			const weightItems = $('.location-widget__input-dropdown-wrapper--inputs-ocean .js-dropdown-parent').find('[data-shorthand="WE"]');
			let sumWeight = 0;
			weightItems.each(function() {
				sumWeight += Number($(this).val());
			});

			const totalAddition = `Amount ${cartonAmount}; ${sumWeight}KG; CBM ${totalSum}`;


			//Write input for Carton Count
			const countAir = $('.location-widget__input-dropdown-wrapper--inputs-ocean .location-widget__input-top-box').find('[data-shorthand="Count"]');
			if(!countAir.val() || countAir.hasClass('input-disabled')) {
				countAir.val(cartonAmount);
			}

			//Write input for KG
			const KgAir = $('.location-widget__input-dropdown-wrapper--inputs-ocean .location-widget__input-top-box').find('[data-shorthand="Weight"]');
			if(!KgAir.val() || KgAir.hasClass('input-disabled')) {
				KgAir.val(sumWeight);
			}

			//Write input for CBM
			const cbmAir = $('.location-widget__input-dropdown-wrapper--inputs-ocean .location-widget__input-top-box').find('[data-shorthand="cbm"]');
			if(!cbmAir.val() || cbmAir.hasClass('input-disabled')) {
				cbmAir.val(totalSum);
			}
		});

		//-----------------------------------------------------------------------------------------

		//STORING CHOSEN ELEMENTS TO MAIN INPUT FIELD

		// On .js-save-widget-options click, store the text of the .js-dropdown element in an array
		$('.js-save-widget-options').on('click', function() {
			const optionsArray = [];

			// Find .location-widget__input-dropdown-button--active and push its text to optionsArray
			optionsArray.push($('.location-widget__input-dropdown-button--active').text().toUpperCase());
			$('.location-widget__input-dropdown-type-wrapper.active .location-widget__input-dropdown-wrapper.active').each(function(e, el) {


				/* //height * width * length
				const totalArr = [];
				let totalSum = 0;
				const allInp = $('.location-widget__input-dropdown-wrapper--inputs-air .js-dropdown-parent').find('.js-location-widget__inputs-box');
				allInp.each(function() {
					const height = Number($(this).find('[data-shorthand="H"]').val());
					const width = Number($(this).find('[data-shorthand="WI"]').val());
					const length = Number($(this).find('[data-shorthand="L"]').val());
					const val = height * width * length / 1000000;
					totalArr.push(val);
				});

				console.log(totalArr);
				for (let i = 0; i < totalArr.length; i++) {
					const element = totalArr[i];
					totalSum += element;
				}
				console.log(`Sum total ${totalSum}`);

				//carton Count
				const cartonItems = $('.location-widget__input-dropdown-wrapper--inputs-air .js-dropdown-parent').find('[data-shorthand="CA"]');
				let cartonAmount = 0;
				cartonItems.each(function() {
					cartonAmount += Number($(this).val());
				});
				console.log(`Carton total ${cartonAmount}`);


				//Weight total
				const weightItems = $('.location-widget__input-dropdown-wrapper--inputs-air .js-dropdown-parent').find('[data-shorthand="WE"]');
				let sumWeight = 0;
				weightItems.each(function() {
					sumWeight += Number($(this).val());
				});
				console.log(`Weight total ${sumWeight}`);

				const totalAddition = `Amount ${cartonAmount}; ${sumWeight}KG; CBM ${totalSum}`;
				console.log(totalAddition); */


				//Check if element has data attribute, and if it has, print that attribute value.
				if($(el).find('.js-dropdown').attr('data-shorthand')) {
					if($('.js-type-btn.red').hasClass('location-widget__input-dropdown-button--active')) {
						$('.js-type').val('AIR');
						$('.js-type').attr('title', 'AIR');
						const airStr = `Carton count: ${$('.location-widget__input-dropdown-wrapper--inputs-air .location-widget__input-top-box').find('[data-shorthand="Count"]').val()}; KG: ${$('.location-widget__input-dropdown-wrapper--inputs-air .location-widget__input-top-box').find('[data-shorthand="Weight"]').val()}; CBM: ${$('.location-widget__input-dropdown-wrapper--inputs-air .location-widget__input-top-box').find('[data-shorthand="cbm"]').val()}`;
						$('.js-type-calc').val(airStr);
						$('.js-type-calc').attr('title', airStr);
					}else {
						$('.js-type').val('OCEAN, LCL');
						$('.js-type').attr('title', 'OCEAN, LCL');
						const oceanStr = `Carton count: ${$('.location-widget__input-dropdown-wrapper--inputs-ocean .location-widget__input-top-box').find('[data-shorthand="Count"]').val()}; KG: ${$('.location-widget__input-dropdown-wrapper--inputs-ocean .location-widget__input-top-box').find('[data-shorthand="Weight"]').val()}; CBM: ${$('.location-widget__input-dropdown-wrapper--inputs-ocean .location-widget__input-top-box').find('[data-shorthand="cbm"]').val()}`;
						$('.js-type-calc').val(oceanStr);
						$('.js-type-calc').attr('title', oceanStr);
					}
					/* $('.js-type').val(totalAddition);
					$('.js-type').attr('title', totalAddition); */

					optionsArray.push($(el).find('.js-dropdown').attr('data-shorthand'));
				} else {
					if($(el).find('.js-dropdown').val() !== '' && $(el).find('.js-dropdown').is('input') && $(el).find('.js-dropdown').parents('.js-input-dropdown-secondary').attr('data-input-type') === 'volume') {
						optionsArray.push($(el).find('.js-dropdown').val()+'CBM');
						optionsArray.push($(el).find('.js-dropdown').attr(''));
					} else if($(el).find('.js-dropdown').val() !== '' && $(el).find('.js-dropdown').is('input') && ($(el).find('.js-dropdown').parents('.js-input-dropdown-secondary').attr('data-input-type') === 'weight')) {
						optionsArray.push($(el).find('.js-dropdown').val()+'KG');
						optionsArray.push($(el).find('.js-dropdown').attr(''));
					} else if($(el).find('.js-dropdown').val() !== '' && $(el).find('.js-dropdown').is('input') && ($(el).find('.js-dropdown').parents('.js-input-dropdown-secondary').attr('data-input-type') === 'gross')) {
						optionsArray.push($(el).find('.js-dropdown').val()+'MT');
						optionsArray.push($(el).find('.js-dropdown').attr(''));
					} else {
						optionsArray.push($(el).find('.js-dropdown').text());
						optionsArray.push($(el).find('.js-dropdown').attr(''));
					}
					$('.js-type').val(optionsArray.filter(item => item).join(', ').replace(/,\s*$/, ''));
					$('.js-type').prop('title', optionsArray.filter(item => item).join(', ').replace(/,\s*$/, ''));
					$('.js-type-calc').val(optionsArray.filter(item => item).join(', ').replace(/,\s*$/, ''));
					$('.js-type-calc').prop('title', optionsArray.filter(item => item).join(', ').replace(/,\s*$/, ''));
				}
			});

			// Set optionsArray to .js-type element
			/* $('.js-type').val(optionsArray.filter(item => item).join(', ').replace(/,\s*$/, '')); */
			/* $('.js-type').val(newSt); */
			//Set title value for element
			/* $('.js-type').prop('title', optionsArray.filter(item => item).join(', ').replace(/,\s*$/, '')); */
			//Close widget after select
			$('.location-widget__input-dropdown').removeClass('active');

			if($('.form-block').length > 0) {
				$('.js-contact-form__box-wrapper-input--type-cargo input').val($('.js-type-calc').val());
			}
		});

		//-----------------------------------------------------------------------------------------

		//LOGIC FOR WHAT KIND OF INPUT FIELDS WILL BE VISIBLE BASED ON WHAT WAS CHOOSEN

		// On load, check data-shorthand attribute and set the value of .js-dropdown element
		const selectDataType = $('.location-widget__input-dropdown-type-wrapper.active').find('.js-main-select').attr('data-type');
		const mainSelect = $('.location-widget__input-dropdown-type-wrapper.active').find('.js-main-select');

		// Checks on load which data attribute value main select has, and sets active class accordingly.
		$('.js-input-dropdown-secondary').each(function(e, el) {
			if($(el).attr('data-input-type') === selectDataType) {
				$(this).addClass('active');
			}
		});

		// Checks on click the data type attribute value, and removes active class for all, except for the matching secondaty input.
		$('.js-main-option').on('click', function() {
			const optionDataType = $(this).attr('data-type');

			mainSelect.attr('data-type', optionDataType);
			$('.js-input-dropdown-secondary').removeClass('active');
			$('.js-input-dropdown-secondary').each(function(e, el) {
				if($(el).attr('data-input-type') === optionDataType) {
					$(this).addClass('active');
				} else if(optionDataType === 'both') {
					$('[data-input-type="weight"]').addClass('active');
					$('[data-input-type="volume"]').addClass('active');
				}
			});
		});

		$('.js-type-btn').on('click', function() {
			const selectDataType2 = $('.location-widget__input-dropdown-type-wrapper.active').find('.js-main-select').attr('data-type');

			$('.js-input-dropdown-secondary').removeClass('active');
			$(this).parents('.location-widget__input-dropdown.active').find(`.location-widget__input-dropdown-type-wrapper.active .js-input-dropdown-secondary[data-input-type="${selectDataType2}"]`).addClass('active');
		});

		//-----------------------------------------------------------------------------------------
	},

};

export default QuoteDetails;
